<template>
    <q-layout view="hHh lpR fFf" style="display: grid">
        <q-page-container :style="$q.screen.width < 485 ? `` : `margin: auto`">
            <q-card flat bordered :class="$q.screen.width < 485 ? `my-card-mobile` : `my-card`">
                <q-card-section>
                    <div class="row justify-center">
                        <q-img basic v-if="$q.screen.width < 485" contain width="50px"
                            :src="require('@/assets/logo-villa-mobile.svg')" />
                        <q-img basic v-else contain width="100px" :src="require('@/assets/logo-villa-mobile.svg')" />
                    </div>
                    <div class="row justify-center">
                        <div class="text-h6">Villa market</div>
                    </div>
                </q-card-section>

                <!-- <q-separator inset /> -->
                <template v-if="sessionExpire">
                    <q-card-section :style="$q.screen.width < 485 ? `min-height: 75vh` : `min-height: 100px`
                        ">
                        <div class="row justify-center">
                            <div class="text-h6">Session expired</div>
                        </div>
                    </q-card-section>
                </template>
                <template v-else-if="loading">
                    <q-card-section>
                        <div class="row justify-center">
                            <q-spinner size="lg" color="primary" />
                        </div>
                    </q-card-section>
                </template>
                <template v-else>
                    <q-card-section>
                        <div class="text-subtitle2">Order {{ order.orderId }}</div>
                        <div class="text-subtitle2">Shipping to</div>
                        <div class="text-subtitle2 no-bold text-grey-8">
                            {{ formatedAddress }}
                        </div>
                        <div class="text-subtitle2">Order summary</div>
                        <div class="text-subtitle2 row justify-between no-bold"
                            v-for="(product, index) in order.productList" :key="index">
                            <div class="text-grey-8">
                                {{ product.productName }} x{{ product.quantity }}
                            </div>
                            <div class="text-primary">฿ {{ product.price }}</div>
                        </div>
                    </q-card-section>

                    <q-card-section>
                        <div class="row full-width justify-between">
                            <div class="text-subtitle2 no-bold">Sub total</div>
                            <div class="text-subtitle2 no-bold">
                                {{ order.subTotal }}
                            </div>
                        </div>
                        <div v-if="order.deliveryFee > 0" class="row full-width justify-between">
                            <div class="text-subtitle2 no-bold">Total delivery fee</div>
                            <div class="text-subtitle2 no-bold">
                                {{ order.deliveryFee | positiveNumber }}
                            </div>
                        </div>
                        <div v-if="order.expressShippingCost > 0" class="row full-width justify-between">
                            <div class="text-subtitle2 no-bold">Express fee</div>
                            <div class="text-subtitle2 no-bold">
                                {{ order.expressShippingCost | positiveNumber }}
                            </div>
                        </div>
                        <div v-if="order.totalDiscount > 0" class="q-my-xs">
                            <div v-if="order.totalDiscount > 0" class="row full-width justify-between">
                                <div class="text-subtitle2 no-bold">Total discount</div>
                                <div class="text-subtitle2 no-bold text-red">
                                    {{ order.totalDiscount | nagativeNumber }}
                                </div>
                            </div>
                            <div v-if="promotionalDiscount > 0"
                                class="row full-width justify-between q-px-md text-grey-8">
                                <div class="text-caption no-bold">Promotional discount</div>
                                <div class="text-caption no-bold text-red">
                                    {{ promotionalDiscount | nagativeNumber }}
                                </div>
                            </div>
                            <div v-if="order.voucherDiscount > 0"
                                class="row full-width justify-between q-px-md text-grey-8">
                                <div class="text-caption no-bold">Voucher discount</div>
                                <div class="text-caption no-bold text-red">
                                    {{ order.voucherDiscount | nagativeNumber }}
                                </div>
                            </div>
                        </div>
                        <div class="row full-width justify-between">
                            <div class="text-subtitle1 text-primary">Total</div>
                            <div class="text-subtitle1 text-primary">
                                ฿ {{ order.grandTotal }}
                            </div>
                        </div>
                    </q-card-section>
                    <q-separator inset />
                    <q-card-section>
                        <div class="text-h5">Choose payment method</div>
                        <q-list bordered separator>
                            <q-item dense tag="label" v-for="(item, index) in paymentMethods" :key="index" clickable
                                v-ripple :disabled="true">
                                <q-item-section avatar>
                                    <q-radio v-model="selectedPaymentMethod" :val="item.value" :disable="true" />
                                </q-item-section>
                                <q-item-section>
                                    <q-item-label>
                                        <div
                                            style="display:flex; justify-content: space-between; align-items: center; width: 100%;">
                                            <div style="white-space: nowrap;">{{ item.title }}</div>
                                            <div
                                                style="display:flex; justify-content: end; align-items: center; gap:8px; max-width: 300px; height: 32px; overflow:hidden;">
                                                <img style="height: 28px !important;" v-for="logo in item.img"
                                                    :key="logo" :src="require(`@/assets/payment/${logo}`)"
                                                    fit="contain" />
                                            </div>
                                        </div>
                                    </q-item-label>
                                </q-item-section>
                            </q-item>
                        </q-list>
                    </q-card-section>

                    <q-separator inset />

                    <q-card-section>
                        <div class="q-mb-md" ref="k-payment-form-container">
                        </div>
                        <q-btn unelevated no-caps no-wrap :loading="paymentLoading" class="full-width" block
                            color="primary" outline label="Change payment method" @click="onChangePaymentMethod">
                            <template v-if="loading" v-slot:loading>
                                <q-spinner class="on-left" />
                            </template>
                        </q-btn>
                    </q-card-section>
                </template>

                <q-card-section>
                    <span class="text-subtitle2">
                        <a href="https://shop.villamarket.com/terms">
                            Terms and conditions
                        </a>
                        and
                        <a href="https://shop.villamarket.com/privacy-policy">
                            Privacy Policy
                        </a>
                    </span>
                </q-card-section>
            </q-card>
        </q-page-container>

    </q-layout>
</template>

<script>
import API from "@aws-amplify/api";
import * as Sentry from "@sentry/browser";

const paymentComponents = {
    "Credit/Debit card": "CreditCardForm",
    Amex: "CreditCardForm",
    Other: "CreditCardForm",
    "Vplus Wallet": "RequestToPayForm",
};

export default {
    name: "CreditCardKbank",
    data() {
        return {
            sessionExpire: false,
            loading: true,
            paymentLoading: false,
            paymentComponents,
            selectedPaymentMethod: "Credit/Debit card",
            order: {
                orderId: "",
                shipping: {
                    address: "",
                },
                productList: [
                ],
                deliveryFee: 60,
                discount: 0,
                subTotal: 866,
                total: 926,
            },
            promotionalDiscount: 0,
            paymentMethods: [
                {
                    title: "Credit/Debit card",
                    value: "Credit/Debit card",
                    img: ["master-card.svg", "visa.svg", "jcb.svg", "union.svg"]
                },
                // {
                //   title: "Vplus Wallet",
                //   value: "Vplus Wallet",
                //   img: ["wallet-logo.png"]
                // },
                {
                    title: "Thai QR",
                    value: "Thai QR",
                    img: ["thai_qr.png"]
                },
                // {
                //   title: "WeChat Pay",
                //   value: "WeChat Pay",
                //   img: ["wechat-pay.png"]
                // },
                // {
                //   title: "Alipay",
                //   value: "Alipay",
                //   img: ["alipay_logo.jpg"]
                // },
                // {
                //   title: "American Express",
                //   value: "AmexV2",
                //   img: ["amex.svg"]
                // },
                {
                    title: "American Express",
                    value: "Amex",
                    img: ["amex.svg"]
                },
            ],
        };
    },
    computed: {
        // ...mapGetters({
        //     loading: "order/loading",
        // }),
        shippingAddress() {
            return this.order.shipping;
        },
        formatedAddress() {
            if (this.shippingAddress) {
                const shippingAddress = this.shippingAddress;
                return `${shippingAddress.shippingAddress} ${shippingAddress.shippingSubDistrict || ""
                    } ${shippingAddress.shippingDistrict || ""} ${shippingAddress.shippingProvince
                    } ${shippingAddress.shippingPostcode}`;
            }
            return "";
        },
        RTP() {
            return this.$route.params.id;
        },
    },
    watch: {
        selectedPaymentMethod: {
            immediate: false,
            handler(value) {
                if (value === "Amex") {
                    this.$store.dispatch("order/configureAmex");
                }
            },
        },
    },
    async mounted() {
        console.log(this.$q.platform);
        console.log("get rtp", this.RTP);
        await this.loadRequestToPay();
        await this.loadKBankScript();
    },
    methods: {
        async loadKBankScript() {
            const form = document.createElement("form");
            form.id = "k-payment-form";
            form.method = "POST";
            form.action = "https://kibxkqpe7d.execute-api.ap-southeast-1.amazonaws.com/production/api/v1/payment/credit-card";

            // add authorization to headers
            const apikey = await this.$services.authentication.getApikey();
            console.log("token", apikey);

            const authInput = document.createElement("input");
            authInput.type = "hidden";
            authInput.name = "Authorization";
            authInput.value = apikey.key;
            form.appendChild(authInput);

            // // add orderid
            const orderIdInput = document.createElement("input");
            orderIdInput.type = "hidden";
            orderIdInput.name = "orderId";
            orderIdInput.value = this.order.orderId;
            form.appendChild(orderIdInput);

            // add amount
            const amountInput = document.createElement("input");
            amountInput.type = "hidden";
            amountInput.name = "amount";
            amountInput.value = this.order.grandTotal;
            form.appendChild(amountInput);

            // Create script element
            const script = document.createElement("script");
            script.type = "text/javascript";
            script.async = true;
            script.src = "https://kpaymentgateway.kasikornbank.com/ui/v2/kpayment.min.js";
            script.setAttribute("data-apikey", "pkey_prod_11069UdTmr16AeGHYvqmiD9AFiNJqNLg3lNDT");
            script.setAttribute("data-amount", this.order.grandTotal);
            script.setAttribute("data-currency", "THB");
            script.setAttribute("data-payment-methods", "card");
            script.setAttribute("data-name", "Villa Market JP");
            script.setAttribute("data-mid", "401012226078001");
            script.setAttribute("data-customer-id", "");
            script.setAttribute("data-order-id", this.order.orderId);
            // Append script to form
            form.appendChild(script);
            // Append form to body
            document.body.appendChild(form);

            // add form to container
            const containerRef = this.$refs["k-payment-form-container"];
            containerRef.appendChild(form);

            return new Promise((resolve) => {
                script.onload = () => {
                    console.log("KBank script loaded");
                    window.KPayment.create();
                    window.KPayment.show();
                    resolve();
                };
            });
        },
        async loadRequestToPay() {
            let rtp;

            try {
                rtp = await this.$services.requestToPay.getRequestToPay(this.RTP);
                console.log({ rtp });

                if (rtp == null || rtp == undefined) {
                    this.sessionExpire = true;
                    return;
                }

                // get current time
                const response = await API.get("saletoolapi", "/time");

                if (response["time"] > rtp.expirationTime) {
                    console.log("session expire");
                    this.sessionExpire = true;
                    return;
                }


                // await this.$services.authentication.getIdToken();
                let order = await this.$services.orders.getOrderById(rtp.orderID, "");

                console.log({ order });
                if (order.payment) {
                    if (order.payment.isPaid == true) {
                        console.log("session expire");
                        this.sessionExpire = true;
                        return;
                    }
                }

                const apikey = await this.$services.authentication.getApikey();
                order = await this.$services.calculatePrice.getResolveCoupon(
                    order,
                    apikey.key
                );

                console.log({ order });

                this.order = order;
                this.order.orderId = rtp.orderID;

                this.promotionalDiscount =
                    (order.bogoDiscount || 0) + (order.cartDiscount || 0);

                this.loading = false;
                // throw Error("Test loadRequestToPay error");
            } catch (error) {
                console.error(error);
                Sentry.captureException(error);
                this.isRequestToPayError = true;
                this.loading = false;
                return;
            }
        },
        onChangePaymentMethod() {
            // go back to whichever payment page sent us here (/pay2 or /pay3)
            const base = this.$route.path.startsWith("/pay3") ? "pay3" : "pay2";
            window.location.href = `/${base}/${this.RTP}`;
        }
    },
};
</script>

<style scoped>
.my-card {
    min-width: 360px;
}

.my-card-mobile {
    width: 100vw;
    height: 100vh;
}

.no-bold {
    font-weight: normal;
}

:deep(.pay-button[_kpayment]) {
    width: 100%;
}
</style>
